import { handleActions } from 'redux-actions';
import { ITrafficMonitorData, TrafficMonitorState } from '../types';
import {
  trafficUsageFetchInitialized,
  trafficUsageFetchSucceeded,
  trafficUsageFetchFailed,
} from '../TrafficMonitor';

type UsageState = TrafficMonitorState['usage'];

const initialState: UsageState = {
  isLoading: true,
  failed: false,
  usage: null,
};

export default handleActions<UsageState, ITrafficMonitorData[]>({
  [trafficUsageFetchInitialized.toString()]: () => initialState,
  [trafficUsageFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    usage: {
      ...state.usage,
      ...payload,
    },
  }),
  [trafficUsageFetchFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
}, initialState);
